import ClientApplicationList from './ClientApplicationList.container';

export default ClientApplicationList;
